export const defaultTxData = [
  {
    id: 1,
    server_id: 1,
    team_id: 1,
    unit: 1,
    modem_number: 1,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 2,
    server_id: 1,
    team_id: 1,
    unit: 1,
    modem_number: 2,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 3,
    server_id: 1,
    team_id: 1,
    unit: 1,
    modem_number: 3,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 4,
    server_id: 1,
    team_id: 1,
    unit: 1,
    modem_number: 4,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 5,
    server_id: 1,
    team_id: 1,
    unit: 2,
    modem_number: 1,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 6,
    server_id: 1,
    team_id: 1,
    unit: 2,
    modem_number: 2,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 7,
    server_id: 1,
    team_id: 1,
    unit: 2,
    modem_number: 3,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 8,
    server_id: 1,
    team_id: 1,
    unit: 2,
    modem_number: 4,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 9,
    server_id: 1,
    team_id: 1,
    unit: 3,
    modem_number: 1,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 10,
    server_id: 1,
    team_id: 1,
    unit: 3,
    modem_number: 2,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 11,
    server_id: 1,
    team_id: 1,
    unit: 3,
    modem_number: 3,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 12,
    server_id: 1,
    team_id: 1,
    unit: 3,
    modem_number: 4,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 13,
    server_id: 1,
    team_id: 1,
    unit: 4,
    modem_number: 1,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 14,
    server_id: 1,
    team_id: 1,
    unit: 4,
    modem_number: 2,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 15,
    server_id: 1,
    team_id: 1,
    unit: 4,
    modem_number: 3,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
  {
    id: 16,
    server_id: 1,
    team_id: 1,
    unit: 4,
    modem_number: 4,
    operational: true,
    antenna_id: 1,
    frequency: 1000,
    bandwidth: 10,
    power: -90,
    transmitting: false,
  },
];
